import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Grid } from '@material-ui/core'
import moment from 'moment'
import config from '../config'

export const PostalVotingPage = (props) => {
  const { ag_id, coowner_id } = useParams()
  const [record, setRecord] = useState()
  useEffect(() => {
    const request = new Request(
      `${config.API_V1}/ags/${ag_id}/vpc/${coowner_id}`,
      {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    )
    fetch(request)
      .then(async (response) => await response.json())
      .then((r) => setRecord(r))
  }, [ag_id])
  const truncate = (str, n) =>
    str.length > n ? `${str.substr(0, n - 1)}...` : str

  return record ? (
    <Grid
      container
      style={{
        padding: '1rem',
        fontFamily: "'Source Sans Pro', sans-pro",
        fontSize: 12,
        display: 'block',
      }}
    >
      <Grid item xs={12} spacing={2}>
        <h1
          style={{
            fontWeight: 'normal',
            color: 'black',
          }}
        >
          Formulaire de vote par correspondance
        </h1>
      </Grid>
      <Grid
        spacing={1}
        item
        container
        xs={12}
        style={{
          borderTop: '1px dotted black',
          borderBottom: '1px dotted black',
          marginBottom: '1rem',
          padding: '1rem 0',
        }}
      >
        <Grid item xs={12}>
          <span
            style={{
              color: 'black',
              fontWeight: 'bold',
            }}
          >
            Copropriété
          </span>
          : #{record.copro_id} - {record.libelle}
        </Grid>
        <Grid item xs={12}>
          {record.adresse} {record.codepostal} - {record.ville}
        </Grid>

        <Grid item xs={12}>
          <span
            style={{
              color: 'black',
              fontWeight: 'bold',
            }}
          >
            Copropriétaire
          </span>
          : {record.coproprietaire}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        Assemblée Générale du{' '}
        {moment(record.date).locale('fr').format('MMMM d YYYY')} selon les
        moyens et supports mentionnés dans la convocation.
      </Grid>
      <Grid item xs={12}>
        Ordre du jour :
      </Grid>
      <Grid item container xs={12}>
        <Grid
          item
          container
          xs={12}
          style={{
            fontWeight: 'bold',
            color: 'white',
            backgroundColor: 'Grey',
            border: 'solid grey',
          }}
        >
          <Grid item xs={1} style={{ textAlign: 'center', padding: '0.5rem' }}>
            N°
          </Grid>
          <Grid item xs={5} style={{ padding: '0.5rem', textAlign: 'center' }}>
            RÉSOLUTION
          </Grid>
          <Grid item xs={2} style={{ padding: '0.5rem', textAlign: 'center' }}>
            POUR*
          </Grid>
          <Grid item xs={2} style={{ padding: '0.5rem', textAlign: 'center' }}>
            CONTRE*
          </Grid>
          <Grid item xs={2} style={{ padding: '0.5rem', textAlign: 'center' }}>
            ABSTENTION*
          </Grid>
        </Grid>
        {record.resolutions_numbers
          .concat(record.resolutions_numbers)
          .map((number, idx) => (
            <Grid
              item
              container
              xs={12}
              style={{
                border: 'solid grey 1px',
              }}
            >
              <Grid
                item
                xs={1}
                style={{
                  textAlign: 'center',
                  borderRight: '1px solid',
                  paddingTop: '0.2rem',
                }}
              >
                {number}
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  borderRight: '1px solid',
                  paddingTop: '0.2rem',
                  paddingLeft: '0.2rem',
                }}
              >
                {truncate(
                  record.resolutions_libelles.concat(
                    record.resolutions_libelles
                  )[idx],
                  50
                )}
              </Grid>
              <Grid
                item
                xs={2}
                style={{
                  borderRight: '1px solid',
                  paddingTop: '0.2rem',
                }}
              ></Grid>
              <Grid
                item
                xs={2}
                style={{
                  borderRight: '1px solid',
                  padding: '0.2rem',
                }}
              ></Grid>
              <Grid
                item
                xs={2}
                style={{
                  borderRight: '1px solid',
                  padding: '0.2rem',
                }}
              ></Grid>
            </Grid>
          ))}

        <Grid
          item
          xs={12}
          style={{
            textAlign: 'right',
          }}
        >
          * cochez la case correspondante
        </Grid>
        <Grid
          item
          container
          xs={12}
          style={{
            border: 'solid grey',
            borderRight: '1px solid',
            padding: '1rem',
            paddingBottom: '4rem',
          }}
        >
          Signature du copropriétaire, de l’associé ou du mandataire commun :
        </Grid>
      </Grid>
      <Grid item>
        <h4>
          Cas des résolutions faisant l’objet d'un second vote "passerelle" dans
          les conditions requises (25-1 et 26-1).et 26-1).
        </h4>
        <p>
          Si une résolution se vote à la majorité de l'article 25 ou 26 et
          n'obtient pas la majorité requise pour une adoption en première
          lecture, mais qu'elle obtient le seuil requis pour passer à un second
          vote passerelle, alors : Veuillez cocher d'une croix une case
          uniquement
        </p>
        <ul>
          <li>je duplique mon vote</li>
          <li>je mentionne mon vote en défaillant</li>
          <li>
            je précise mes votes passerelles (veuillez remplir le tableau
            ci-dessous nommé "Second(s) vote(s) passerelle(s)", si celui-ci
            n'est pas rempli vos seconds votes passerelles seront considérés
            comme défaillants)
          </li>
        </ul>
      </Grid>
      <Grid
        item
        container
        xs={12}
        style={{
          breakInside: 'avoid',
        }}
      >
        <Grid
          item
          container
          xs={12}
          style={{
            fontWeight: 'bold',
            color: 'white',
            backgroundColor: 'Grey',
            border: 'solid grey',
          }}
        >
          <Grid item xs={12} style={{ textAlign: 'center', padding: '0.5rem' }}>
            SECOND(S) VOTE(S) PASSERELLE(S)
          </Grid>
          <Grid item xs={1} style={{ textAlign: 'center', padding: '0.5rem' }}>
            N°
          </Grid>
          <Grid item xs={5} style={{ padding: '0.5rem', textAlign: 'center' }}>
            RÉSOLUTION
          </Grid>
          <Grid item xs={2} style={{ padding: '0.5rem', textAlign: 'center' }}>
            POUR*
          </Grid>
          <Grid item xs={2} style={{ padding: '0.5rem', textAlign: 'center' }}>
            CONTRE*
          </Grid>
          <Grid item xs={2} style={{ padding: '0.5rem', textAlign: 'center' }}>
            ABSTENTION*
          </Grid>
        </Grid>
        {record.revotable.map((revotable, idx) => (
          <Grid
            item
            container
            xs={12}
            style={{
              border: 'solid grey 1px',
            }}
          >
            <Grid
              item
              xs={1}
              style={{
                textAlign: 'center',
                borderRight: '1px solid',
                paddingTop: '0.2rem',
              }}
            >
              {revotable.revotable_numero}
            </Grid>
            <Grid
              item
              xs={5}
              style={{
                borderRight: '1px solid',
                paddingTop: '0.2rem',
                paddingLeft: '0.2rem',
              }}
            >
              {truncate(revotable.revotable_libelle, 50)}
            </Grid>
            <Grid
              item
              xs={2}
              style={{
                borderRight: '1px solid',
                paddingTop: '0.2rem',
              }}
            ></Grid>
            <Grid
              item
              xs={2}
              style={{
                borderRight: '1px solid',
                padding: '0.2rem',
              }}
            ></Grid>
            <Grid
              item
              xs={2}
              style={{
                borderRight: '1px solid',
                padding: '0.2rem',
              }}
            ></Grid>
          </Grid>
        ))}
        <Grid
          item
          xs={12}
          style={{
            textAlign: 'right',
          }}
        >
          * cochez la case correspondante
        </Grid>
        <Grid
          item
          container
          xs={12}
          style={{
            border: 'solid grey',
            borderRight: '1px solid',
            padding: '1rem',
            paddingBottom: '4rem',
          }}
        >
          Signature du copropriétaire, de l’associé ou du mandataire commun :
        </Grid>
      </Grid>
      <Grid item style={{ breakInside: 'avoid' }}>
        <h2>Rappel : Dispositions légales et réglementaires</h2>
        <h3>La prise de décisions</h3>
        <p>
          Il s’agit du formulaire prévu par l’alinéa 2 de l’article 17-1 A de la
          loi n° 65-557 du 10 juillet 1965l’alinéa 2 de l’article 17-1 A de la
          loi n° 65-557 du 10 juillet 1965 qui précise que : « Les
          copropriétaires peuvent, par ailleurs, voter par correspondance avant
          la tenue de l'assemblée générale, au moyen d'un formulaire établi
          conformément à un modèle Vxé par arrêté. Si la résolution objet du
          vote par correspondance est amendée en cours d'assemblée générale, le
          votant par correspondance ayant voté favorablement est assimilé à un
          copropriétaire défaillant pour cette résolution. »
        </p>
        <p>
          Ce formulaire est régi par les articles 9 alinéa 2, 9 bis, 14, 14-1 et
          17 alinéa 3 du décret n° 67-223 du 17 mars 1967 modiVé pris pour
          l'application de la loi n° 65-557 du 10 juillet 1965 Vxant le statut
          de la copropriété des immeubles bâtis, selon lesquels :
        </p>
        <h3>Alinéa 2 de l'article 9 :</h3>
        <p>
          « Le formulaire de vote par correspondance mentionné au deuxième
          alinéa de l’article 17-1 A est joint à la convocation. »
        </p>
        <h3>Article 9 bis :</h3>
        <p>
          « Lorsque le copropriétaire ou l’associé vote par correspondance, il
          transmet au syndic, par tout moyen permettant d’établir avec certitude
          la date de sa réception, le formulaire joint à la convocation trois
          jours francs au plus tard avant la réunion de l’assemblée générale. A
          défaut, il n’est pas tenu compte des votes exprimés dans ce
          formulaire. »
        </p>
        <h3>Article 14 :</h3>
        <p>
          « Il est tenu une feuille de présence, pouvant comporter plusieurs
          feuillets, qui indique les nom et domicile de chaque copropriétaire ou
          associé :
        </p>
        <ul>
          <li> Présent physiquement ou représenté ;</li>
          <li>
            Participant à l’assemblée générale par visioconférence, par
            audioconférence ou par un autre moyen de communication électronique
            ;
          </li>
          <li>
            Ayant voté par correspondance avec mention de la date de réception
            du formulaire par le syndic et, le cas échéant, ceux dont le vote,
            remis hors délai au syndic, a été écarté. »
          </li>
        </ul>
        <h3>Article 14-1 :</h3>
        <p>
          « Le formulaire de vote par correspondance n’est pas pris en compte
          lorsque le copropriétaire, l’associé ou leur mandataire est présent à
          l’assemblée générale. »
        </p>
        <h3>Alinéa 3 de l’article 17 :</h3>
        <p>
          « Le procès-verbal comporte, sous l'intitulé de chaque question
          inscrite à l'ordre du jour, le résultat du vote. Il précise les noms
          et nombre de voix des copropriétaires ou associés qui se sont opposés
          à la décision, qui se sont abstenus, ou qui sont assimilés à un
          défaillant en application du deuxième alinéa de l’article 17-1 A de la
          loi du 10 juillet 1965. »
        </p>
      </Grid>
    </Grid>
  ) : null
}
